enum LegalDocumentsConstants {
  GET_LEGAL_DOCUMENTS = '@LegalDocumentsContainer/GET_LEGAL_DOCUMENTS',
  GET_LEGAL_DOCUMENTS_REQUEST = '@LegalDocumentsContainer/GET_LEGAL_DOCUMENTS_REQUEST',
  GET_LEGAL_DOCUMENTS_REQUEST_SUCCESS = '@LegalDocumentsContainer/GET_LEGAL_DOCUMENTS_REQUEST_SUCCESS',
  GET_LEGAL_DOCUMENTS_REQUEST_ERROR = '@LegalDocumentsContainer/GET_LEGAL_DOCUMENTS_REQUEST_ERROR',
}

export default LegalDocumentsConstants;
